<script setup>
import { ref } from 'vue'

// eslint-disable-next-line no-unused-vars
const JSLoad = ref(true)
</script>

<template>
    <div v-if="jsLoad">
        <h1 class="tCenter">
            JS is required to render this application
        </h1>
        <h2 class="tCenter">
            Please make sure it is enabled in your browser
        </h2>
    </div>
</template>
